"use client";

import { useSession } from "next-auth/react";
import { useLocale } from "next-intl";
import Link from "next/link";
import { FC, useContext, useEffect, useState } from "react";

import { useNotification } from "@/components/NotificationProvider/NotificationProvider";
import ShortlistPopup from "@/components/Shortlist/ShortlistPopup";
import Icon from "@/components/ui/Icon/Icon";
import { ShortlistContext } from "@/context/ShortlistContext";
import { favoritesCartInteractionTracking } from "@/dataLayer/dataLayer";
import { FavoriteItem } from "@/types";

interface WishlistIconProps {
  iconClass?: string;
  textClass?: string;
  hideCounter?: boolean;
}

const WishlistIcon: FC<WishlistIconProps> = ({ iconClass, textClass, hideCounter }) => {
  const { favorites, setFavorites } = useNotification();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const locale = useLocale();
  const { data: session } = useSession();

  const handleClick = () => {
    if (session?.user.source === "credentials" && !isVisible && !favorites.length) {
      return;
    }
    setIsVisible(!isVisible);
    if (!isVisible) {
      favoritesCartInteractionTracking("view_favorites", favorites.length);
    }
  };

  const { units } = useContext(ShortlistContext);
  useEffect(() => {
    setFavorites(units);
  }, [setFavorites, units]);

  return (
    <>
      <Link
        href={`/${locale}/shortlist/`}
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
        title={"Shortlist"}
        className="flex flex-row"
      >
        <Icon name="heart-empty" size="20" className={iconClass ? iconClass : "stroke-black"} />
        {!hideCounter && (
          <span className={`font-medium text-s font-secondary pl-xs pt-[2px] ${textClass ? textClass : "text-black"}`}>
            {favorites?.length > 0 ? `(${favorites.length})` : ""}
          </span>
        )}
      </Link>
      {isVisible && <ShortlistPopup closeFunc={() => setIsVisible(false)} items={favorites} />}
    </>
  );
};
export default WishlistIcon;
